import "./index.css";
import {useSetting} from "../../../contexts/setting";
import {useImages} from "../../../contexts/images";
import BgTransformer from "../../../layout/BgTransformer";
import adsAssets from "../../../data/ads-assets.json";

/**
 * RedditThumb2Ads — bg-only thumbnail. Per the Figma source (node 1733:150),
 * this template has NO bubble and NO editable text — just the rotated photo
 * filling the frame. Kept aligned with the channel's wrapper conventions
 * (.tpl-card > .tpl-card__inner > .bg-transformer) so the export pipeline
 * picks it up correctly.
 */
const RedditThumb2Ads = ({id, zoom}) => {
  const {channel, product, type, bgOption, locked} = useSetting();
  const {customBgs} = useImages();
  const isLocked = locked.some((x) => x === id);
  // Per-template custom bg wins over the shared one (only when locked);
  // unlocking falls back to .main automatically.
  const customBgUrl = (isLocked ? customBgs[id] : undefined) || customBgs.main || null;

  // Manifest miss is expected during channel-switch transitions (URL params
  // updated before useSetting commits) and for combos that haven't been baked
  // yet. Soft-fall-through: skip the background rather than crashing the page.
  const bgIdx = bgOption || 1;
  const assetKey = `${channel.value}/${product.value}/${type.value}/${bgIdx}/${id}`;
  const bgUrl = adsAssets[assetKey]?.url;

  return (
    <div id={id} className={`template ${type.value} tpl-card`} style={{"--zoom-level": zoom}}>
      <div className="tpl-card__inner">
        {customBgUrl || bgUrl ? <BgTransformer src={customBgUrl || bgUrl} id={id} /> : null}
      </div>
    </div>
  );
};

export default RedditThumb2Ads;
